import React, { useRef, useState, useEffect } from 'react';
import styles from '../Catalog.module.css';

const MAX_LINES = 14;

const Card = ({
                  imageUrl,
                  title,
                  description,
                  gameSystemName,
                  gameFormat,
                  cost,
                  isCampaign,
                  minAge
              }) => {
    const textRef = useRef(null);

    const [expanded, setExpanded] = useState(false);
    const [showToggle, setShowToggle] = useState(false);
    const [maxLines, setMaxLines] = useState(MAX_LINES);

    useEffect(() => {
        const resizeHandler = () => setMaxLines(MAX_LINES);
        window.addEventListener('resize', resizeHandler);
        return () => window.removeEventListener('resize', resizeHandler);
    }, []);

    useEffect(() => {
        const el = textRef.current;
        if (!el) return;

        const update = () => setShowToggle(el.scrollHeight > el.clientHeight + 1);

        update();                 // при первом рендере
        const ro = new ResizeObserver(update); // реагируем на смену ширины/шрифтов
        ro.observe(el);

        return () => ro.disconnect();
    }, [description, maxLines]);


    const handleToggle = () => setExpanded(prev => !prev);

    return (
        <div className={styles.cardContent}>
            <div>
                <img src={imageUrl ?? '/images/plug.avif'} alt={'Картинка ' + title} />
            </div>

            <div className="d-flex flex-column justify-content-between">
                <div>
                    <h3 title={title}  className={styles.oneShotTitle}>{title}</h3>
                    <span className={styles.options}>
                        {gameSystemName} | {formatGameFormat(gameFormat)} | {cost}₽{isCampaign ? '/сессия' : ''} | {minAge ? minAge + "+" : "-"}
                    </span>
                </div>

                <div className={styles.textWrapper}>
                    <p
                        ref={textRef}
                        className={`${styles.oneShotDescription} ${
                            expanded
                                ? styles.expanded
                                : styles[`collapsed--${maxLines}`]
                        }`}
                    >
                        {description}
                    </p>

                    {!expanded && showToggle && (
                        <button className={styles.readMoreOverlay} onClick={handleToggle}>
                            …Далее
                        </button>
                    )}
                    {expanded && (
                        <button className={styles.inlineButton} onClick={handleToggle}>
                            Скрыть
                        </button>
                    )}

                </div>
            </div>
        </div>
    );
};

const formatGameFormat = (format) => {
    const map = { ONLINE: 'Online', OFFLINE: 'Offline' };
    return map[format] || 'Online/Offline';
};

export default Card;
